import React from "react";
import { Link } from "react-router-dom";
import "../css/delivery.scss";

function Delivery() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="delivery-page" aria-labelledby="shipping-title">
      <div className="policy-inner">
        <header className="policy-intro">
          <p className="policy-eyebrow">Shop policies · 01</p>
          <h1 id="shipping-title">shipping &amp; delivery</h1>
          <p className="policy-deck">
            Carefully packed in Hong Kong, then sent on its way to you.
          </p>
        </header>

        <div className="policy-list">
          <section className="policy-section" aria-labelledby="processing-time">
            <span className="policy-number" aria-hidden="true">01</span>
            <div className="policy-section-copy">
              <h2 id="processing-time">Processing time</h2>
              <p>
                Please allow 3–5 business days for an order to be prepared before it
                ships. We inspect every piece before dispatch.
              </p>
            </div>
          </section>

          <section className="policy-section" aria-labelledby="packaging-carrier">
            <span className="policy-number" aria-hidden="true">02</span>
            <div className="policy-section-copy">
              <h2 id="packaging-carrier">Packaging &amp; carrier</h2>
              <p>
                Orders are dispatched from Hong Kong with tracked delivery. Jewellery is
                protected in a secure mailer so it reaches you in good condition.
              </p>
            </div>
          </section>

          <section className="policy-section" aria-labelledby="rates-upgrades">
            <span className="policy-number" aria-hidden="true">03</span>
            <div className="policy-section-copy">
              <h2 id="rates-upgrades">Rates, upgrades &amp; insurance</h2>
              <p>
                Standard tracked shipping is USD 9.99 per order. Any destination duties or
                taxes remain the recipient's responsibility where applicable.
              </p>
            </div>
          </section>

          <section className="policy-section" aria-labelledby="delivery-responsibility">
            <span className="policy-number" aria-hidden="true">04</span>
            <div className="policy-section-copy">
              <h2 id="delivery-responsibility">Once a parcel is in transit</h2>
              <p>
                pmistpearl cannot assume responsibility for packages that are lost or
                stolen after shipment. If this is a concern, please ask about insurance
                before placing your order.
              </p>
            </div>
          </section>

          <section className="policy-section" aria-labelledby="international-delivery">
            <span className="policy-number" aria-hidden="true">05</span>
            <div className="policy-section-copy">
              <h2 id="international-delivery">International delivery</h2>
              <p>
                International delivery is available to supported destinations shown at
                checkout. We do not ship to destinations restricted by applicable sanctions.
              </p>
            </div>
          </section>

          <section className="policy-section" aria-labelledby="gift-orders">
            <span className="policy-number" aria-hidden="true">06</span>
            <div className="policy-section-copy">
              <h2 id="gift-orders">Sending a gift</h2>
              <p>
                Each order is packed securely and without third-party branding. Gift notes
                are not currently available.
              </p>
            </div>
          </section>
        </div>

        <aside className="policy-contact" aria-label="Shipping contact information">
          <p className="policy-contact-label">A delivery question?</p>
          <p>
            Write to <a href="mailto:service@pmistpearl.work">service@pmistpearl.work</a>
            <br />
            Need to send something back? Read our {" "}
            <Link to="/returns" onClick={toTop}>returns &amp; exchanges policy</Link>.
          </p>
        </aside>
      </div>
    </main>
  );
}

export default Delivery;
